import axios from 'axios'
import React,{useEffect, useState} from 'react'
import toast from 'react-hot-toast'
import { SERVER_URL } from '../Config'
import { jwtDecode } from 'jwt-decode'
import { Navigate, useNavigate } from 'react-router-dom'

export default function Login() {
    const [disabled,setdisabled] = useState(false)
    const[data,setdata]=useState({
        email:'',
        password:''
    })
    const navigate = useNavigate()
    console.log(data,'data')
    const LoginAdmin = async()=>{
        try{
            console.log(data)
            if(!data.email || !data.password){
                toast.error('Email and Password is Mandatory!!!')
                return false
            }
            setdisabled(true);
            await axios.post(`${SERVER_URL}/api/admin/login`,data).then((res)=>{
                console.log(res)
                console.log(res.data.data)
                if(res.data.status == true){
                    toast.success('Logging you in...')
                    sessionStorage.setItem('__token', res.data.data.token);
                    setTimeout(() => {
                      localStorage.setItem('history', JSON.stringify(res.data.data.history));
                      localStorage.setItem('prices', JSON.stringify(res.data.data.cryptoPrices));
                      navigate('/admin/dashboard');
                    }, 2000);                    
                }else{
                    toast.error(res.data.msg)
                    setdisabled(false);
                    return false
                }
            })
        }catch(err){
            toast.error('Soomething went wrong..')
            setdisabled(false);
            return false
        }
    }
    const isTokenExpired = () => {
        const token = sessionStorage.getItem("__token");
        console.log(token,'token')
        if (token) {
          const decodedToken = jwtDecode(token);
          console.log(decodedToken,'decode token')
          return decodedToken && decodedToken.exp * 1000 < Date.now();  
        }
        return true; 
      };
      const isAuthenticated = () => {
        return sessionStorage.getItem("__token") && !isTokenExpired();
      };

      useEffect(()=>{
       if(isAuthenticated()){
        window.location = '/admin/dashboard?_token=' + sessionStorage.getItem('__token');
    }
      },[])
  return (
    <div>
<div className="main-wrapper account-wrapper bg-wrapper">
  <div className="account-page">
    <div className="account-center">
      <div className="account-logo">
        <a href="#">
          <img src="/assets/img/logo.png" style={{width:'70px'}} alt="Logo" />
        </a>
      </div>
      <div className="account-box">
        <div className="login-header">
          <h3>Let's Get Started</h3>
          <p>Sign in to continue to Crypto</p>
        </div>
        <form className="form-signin">
          <div className="form-group">
            <input
              type="email"
              autofocus=""
              className="form-control"
              placeholder="email"
              required
              onChange={(e)=>setdata({ ...data,email:e.target.value})}
            />
            <span className="profile-views">
              <img src="/assets/img/icon/lock-icon-01.svg" alt="" />
            </span>
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              onChange={(e)=>setdata({ ...data,password:e.target.value})}

            />
            <span className="profile-views">
              <img src="/assets/img/icon/lock-icon-02.svg" alt="" />
            </span>
          </div>
          <div className="forgotpass">
            <div className="remember-me">
              <label className="custom_check me-2 mb-0 d-inline-flex remember-me">
                {" "}
                Remember me
                <input type="checkbox" name="radio" />
                <span className="checkmark" />
              </label>
            </div>
            {/* <a href="forgot-password.html">
              <img
                src="/assets/img/icon/lock-icon.svg"
                className="me-1"
                alt=""
              />
              Forgot your password?
            </a> */}
          </div>
          <div className="form-group text-center">
            <button type="button" onClick={LoginAdmin} disabled={disabled} className="btn btn-primary account-btn">
              Sign In <i className="fas fa-arrow-right ms-1" />
            </button>
          </div>
         
        </form>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}
